import { useModal } from 'components/Modal/hooks/useModal';
import { DeleteFilePrompt } from 'components/WorkspaceFiles/DeleteFilePrompt';

export const useDeleteFilePrompt = () => {
  return useModal(DeleteFilePrompt);
};